import { useLingui } from '@lingui/react/macro';
import type { ComponentProps } from 'react';

import { cn } from './cn';

export type SpinnerProps = ComponentProps<'span'> & {
  /** Texto para leitor de tela. Padrão: "Carregando". `null` quando o pai já anuncia. */
  readonly label?: string | null;
};

/** Indicador de carregamento; herda a cor do texto e o tamanho de ícone da plataforma. */
export function Spinner({ className, label, ...props }: SpinnerProps) {
  const { t } = useLingui();
  const text = label === undefined ? t`Carregando` : label;
  return (
    <span
      role={text === null ? undefined : 'status'}
      aria-label={text ?? undefined}
      aria-hidden={text === null ? true : undefined}
      data-slot="spinner"
      className={cn(
        'inline-block size-icon shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent',
        className,
      )}
      {...props}
    />
  );
}
